export { default as UiCaption } from "./UiCaption";
